import {
    battery,
    batteryDead, calibrationMinMax, lastCalibration,
    lastData, lastSeen,
    motorSpeed,
    pidAlgoPeriod,
    radioId,
    voltageDrop,
} from '~/helpers/fields-description';
import { rfStatus } from '~/helpers/network-fields-description';
import { DevicesModule } from '~/store/modules/devices';
import { NAModule } from '../NAModule.model';

export class NRV extends NAModule {
    hasOperationImportData = false;
    hasOperationReset = false;
    hasOperationDissociate = false;

    battery_threshold?: number;

    battery_levels = ['verylow', 'low', 'medium', 'high', 'full'];

    rf_status?: number;
    radio_id?: string;
    valve_calibration?: {
        min_position: string,
        max_position: string,
        calibration_error: number,
        time: number,
    };
    motor_frequency?: number;
    motor_voltage_drop?: number;
    battery_dead?: boolean;
    pid_algo_period?: number;

    isWired = false;

    loadData(data: any) {
        super.loadData(data);
        // Set outdated value depending on gateway type
        if (this.bridge) {
            const gw = DevicesModule.getDeviceById(this.bridge);
            if (gw) {
                this.MAX_TIME_BEFORE_UNKNOWN = ['BNS', 'OTH'].includes(gw.type) ? 6 * 3600 : 2 * 3600;
            }
        }
    }

    get fieldBattery() {
        return battery(this.getBatteryIcon(this.battery_threshold), this.battery_vp);
    }
    get fieldRfStatus() {
        return rfStatus(this.getRfIcon(this.rf_status), this.rf_status);
    }
    get fieldLastSeen() {
        return lastSeen(this.last_seen, this.outdatedLastSeen ? 'error--text' : '');
    }
    get fieldLastData() {
        return lastData(this.last_data, this.outdatedLastData ? 'error--text' : '');
    }
    get fieldRadioId() {
        return radioId(this.radio_id);
    }
    get fieldCalibrationMinMax() {
        if (this.valve_calibration) {
            let value = '';

            if (
                typeof this.valve_calibration.min_position !== 'undefined'
                && typeof this.valve_calibration.max_position !== 'undefined'
            ) {
                value += this.valve_calibration.min_position + '/' + this.valve_calibration.max_position;
            }

            if (this.valve_calibration.calibration_error !== 0) {
                const error = 'Error ' + this.calibrationErrors[this.valve_calibration.calibration_error] + '';
                value += (value === '') ? error : ' (' + error + ')';
            }
            return calibrationMinMax(value);
        }
    }
    calibrationErrors = [
        'OK',
        'Motor base not reached',
        'Valve disconnected',
        'Critical battery',
        'Low battery',
        'Bad calibration',
        'Far calibration',
        'No min detected',
        'Valve obstructed',
        'Motor Cap',
        'Not calibrated yet',
    ];
    get fieldLastCalibration() {
        if (this.valve_calibration) {
            return lastCalibration(this.valve_calibration?.time);
        }
    }
    get fieldMotorSpeed() {
        if (typeof this.motor_frequency !== 'undefined') {
            return motorSpeed(this.motor_frequency);
        }
    }
    get fieldVoltageDrop() {
        if (typeof this.motor_voltage_drop !== 'undefined') {
            return voltageDrop(this.motor_voltage_drop);
        }
    }
    get fieldBatteryDead() {
        if (typeof this.battery_dead !== 'undefined') {
            return batteryDead(this.battery_dead);
        }
    }
    get fieldPidAlgoPeriod() {
        if (typeof this.pid_algo_period !== 'undefined') {
            return pidAlgoPeriod(this.pid_algo_period);
        }
    }

    getBatteryIcon(battery_threshold?: number) {
        const threshold = battery_threshold ? this.battery_levels[battery_threshold] || 'verylow' : 'verylow';
        return `battery_${threshold}`;
    }
}
